import { defineMessages } from 'react-intl';

export default defineMessages({
    updatingSideBySideGeneric: {
        id: 'easidebysidecontainer.component.Updating Side-by-Side Quotes',
        defaultMessage: 'Updating Side-by-Side Quotes'
    }
});
